import type { ProductEligibility } from "../product.types";
import { productEligibilityResponseSchema } from "../schemas/product-eligibility.schema";

export function parseProductEligibility(
    raw: unknown,
): Record<string, ProductEligibility> {
    const result = productEligibilityResponseSchema.safeParse(raw);
    if (!result.success) return {};

    const map: Record<string, ProductEligibility> = {};
    for (const doc of result.data.Products.docs) {
        map[doc.id] = {
            eligibleForWindowDecoration:
                doc.productType?.eligibleForWindowDecoration === true,
            eligibleForSunProtection:
                doc.productType?.eligibleForSunProtection === true,
        };
    }
    return map;
}
